import { useState } from 'react'

export const MarketingCamp = () => {
    // POSTER
    const [posterList, setPosterList] = useState([])
    const [loader, setLoader] = useState(true)
    const [openModal, setOpenModal] = useState({ template: false, custom: false })
    const [form, setForm] = useState({  confirmation: false, error: false, loader: false, method: 'create', saving_type: '', with_job_acc: false, violator: false,
        // company_logo: {value: '', object: "https://marketing-system-repo.s3.amazonaws.com/mt/phases/1753767188732.png", name: "Ellipse 751.png", size: 1848, type: "default",  stat: false, msg: ''},
        // ft_image: {value: '', object: "https://marketing-system-repo.s3.amazonaws.com/mt/phases/1753766821641.png", name: "image 17.png", size: 81516, type: "default",  stat: false, msg: ''},
        // bg_image: {value: '', object: "https://marketing-system-repo.s3.amazonaws.com/mt/phases/1753782085010.png", name: "Group 57799", size: 208676, type: "default",  stat: false, msg: ''},
        // violator_image: {value: '', object: "https://marketing-system-repo.s3.amazonaws.com/mt/phases/1753766821543.png", name: "vector_img.png", size: 289, type: "default",  stat: false, msg: ''},
        // company_name: 'Yans Corp.', tagline: 'Be part of our Extraordinary and Heroic Journey', work_location: '', job_vacancy: '', 
        // link: '',  poster_name: '',   
        // qualification: [ 
        //     {value: "Integrate applocations with REST APIS", stat: false, msg: ''}, 
        //     {value: "Knowledge of GIT/Bucket", stat: false, msg: ''},
        //     {value: "Strong problem-solving", stat: false, msg: ''},
        //     {value: "Develop and maintain mobile application Integrate applocations with REST APIS", stat: false, msg: ''},

        // ],
        // company_name_color: "#5B6167", tagline_color: "#292C2F",
        // job_vacancy_color: "#22A06B", location_color: "#283745", qualification_bg: "#D6D9DB8F",
        // qualification_text_color: "#292C2F", qualification_list_color: "#292C2F"
    })
    const [templateList, setTemplateList] = useState([])
    const [templateLoader, setTemplateLoader] = useState(true)
    const [selectedTemplate, setSelectedTemplate] = useState(null)
    const [custom, setCustom] = useState('')
    const [job, setJob] = useState({list: [], qualification: []})
    const [copied, setCopied] = useState(false);
    const [preview, setPreview] = useState({open: false, image: ''});
    const [formLoader, setFormLoader] = useState(true);
    const [validateTab, setValidateTab] = useState({content: false, design: false, details: false})
    const [hasChanged, setHasChanged] = useState(false)
    const [required, setRequired] = useState([])
    // TRAINING POSTER
    const [trngForm, setTrngForm] = useState(/*{
        bgimage: { value: 'https://marketing-system-repo.s3.amazonaws.com/mt/phases/1754553024530.jpg' },
        logos: [
            { value: 'https://marketing-system-repo.s3.amazonaws.com/mt/phases/1754553720810.png' }, 
            { value: 'https://marketing-system-repo.s3.amazonaws.com/mt/phases/1754553720820.png' }
        ],
        heading: { value: 'RE-run', color: '#177E0D', stat: false },
        sub_heading: { value: 'EPR 2025 DEADLINE SUBMISSION', color: '#177E0D', stat: false },
        title: { value: "Don't Miss the 2025 EPR Filing Deadline - What You Need To Know", color: '#292C2F', stat: false },
        speakers: [
            {
                img: { value: 'https://marketing-system-repo.s3.amazonaws.com/mt/phases/1754553720818.jpg' },
                name: { value: 'ISABELLA MARIE D. REYES, CPA', color: '#292C2F', stat: false },
                description: { value: 'Audit Manager, Financial Advisory Head', color: '#292C2F', stat: false },
                company: { value: 'Santos & Delos Reyes Accounting Firm', color: '#292C2F', stat: false },
                border: { color: '#009F4D' }
            },
            {   
                img: { value: 'https://marketing-system-repo.s3.amazonaws.com/mt/phases/1754553720815.jpg' },
                name: { value: 'JUAN MIGUEL P. CRUZ, MBA', color: '#292C2F', stat: false },
                description: { value: 'Managing Partner, Business Strategy Head', color: '#292C2F', stat: false },
                company: { value: 'Cruz & Associates Consulting', color: '#292C2F', stat: false },
                border: { color: '#009F4D' }
            }
        ],
        button: { value: 'Register Now', color: '#ffffff', bg_color: '#1BAC0D', stat: false },
        calendar: { color: '#8EEEFD', border_color: '#FFFFFF', bg_color: '#070606' },
        time: { value: '10:00 AM - 12:NN', color: '#ffffff', stat: false },
        date: { value: 'June 16 & 23, 2025', color: '#ffffff', stat: false },
        location: { value: 'Ortigas, Pasig City', color: '#ffffff', stat: false },
        dis_and_ins_title: { value: 'Discussion and Insights', color: '#FFFBFB' },
        dis_and_ins: { value: "<ul><li>Clear walkthrough of what's required under EPR</li><li>Practical guidance on how to file correctly</li><li>What will the Audit Requirements Be</li><li>The Basics of EPR Law</li></ul>", color: '#FFFBFB', stat: false },
        violator: { value: 'https://marketing-system-repo.s3.amazonaws.com/mt/phases/1753766821543.png', show: false },
        divider: { bg_color: '#FFFBFB' },
        footer: { bg_color: '#052702' },
        poster_name: { value: '', stat: false }
    }*/);
    const [trngCustom, setTrngCustom] = useState('');
    const [trngModals, setTrngModals] = useState({ confirmation: false, success: false });
    const [trngLoaders, setTrngLoaders] = useState({ init: false, submit: false });
    const [trngSavingType, setTrngSavingType] = useState('');
    const trngNewSpkr = {
        img: { value: 'https://marketing-system-repo.s3.amazonaws.com/mt/phases/1754553720818.jpg' },
        name: { value: 'ISABELLA MARIE D. REYES, CPA', color: '#292C2F', stat: false },
        description: { value: 'Audit Manager, Financial Advisory Head', color: '#292C2F', stat: false },
        company: { value: 'Santos & Delos Reyes Accounting Firm', color: '#292C2F', stat: false },
        border: { color: '#009F4D' }
    }
    const [trngError, setTrngError] = useState(false)
    const [trngSlctdTmplt, setTrngSlctdTmplt] = useState({});
    const [trngTabsErr, setTrngTabsErr] = useState({ content: false, details: false, tabs: false })
	// PLAN -> CREATIVE BRIEF
	const [cbForm, setCbForm] = useState({
		project_title: { value: '', stat: false },
		background_overview: { value: '', stat: false },
		objective: [{ value: '', stat: false }],
		key_message: { value: '', stat: false },
		reason_to_believe: [{ value: '', stat: false }],
		tone_and_style: [{ value: '', stat: false }],
		deliverables: [{ value: '', stat: false }],
		target_audience: [{ value: '', stat: false }],
		timeline: [{ value: '', stat: false }],
		call_to_action: { value: '', stat: false },
	});
	const cbFormDflt = {
		project_title: { value: '', stat: false },
		background_overview: { value: '', stat: false },
		objective: [{ value: '', stat: false }],
		key_message: { value: '', stat: false },
		reason_to_believe: [{ value: '', stat: false }],
		tone_and_style: [{ value: '', stat: false }],
		deliverables: [{ value: '', stat: false }],
		target_audience: [{ value: '', stat: false }],
		timeline: [{ value: '', stat: false }],
		call_to_action: { value: '', stat: false },
	}
	const [cbSubmit, setCbSubmit] = useState({ modal: false, submit: false, success: false })
	const [cbError, setCbError] = useState({ error: false, in_flds: false })
	const [cbLists, setCbLists] = useState([])
	const [cbLoader, setCbLoader] = useState({ list: false })

    return {
        // POSTER
        posterList: {data: posterList, set: setPosterList},
        loader: {data: loader, set: setLoader},
        openModal: {data: openModal, set: setOpenModal},
        form: {data: form, set: setForm},
        templateList: {data: templateList, set: setTemplateList},
        templateLoader: {data: templateLoader, set: setTemplateLoader},
        selectedTemplate: {data: selectedTemplate, set: setSelectedTemplate},
        custom: {data: custom, set: setCustom},
        job: {data: job, set: setJob},
        copied: {data: copied, set: setCopied},
        preview: {data: preview, set: setPreview},
        formLoader: {data: formLoader, set: setFormLoader},
        validateTab: {data: validateTab, set: setValidateTab},
        hasChanged: {data: hasChanged, set: setHasChanged},
        required: {data: required, set: setRequired},
        // TRAINING POSTER
        trngForm: {data: trngForm, set: setTrngForm},
        trngCustom: {data: trngCustom, set: setTrngCustom},
        trngModals: {data: trngModals, set: setTrngModals},
        trngLoaders: {data: trngLoaders, set: setTrngLoaders},
        trngSavingType: {data: trngSavingType, set: setTrngSavingType},
        trngNewSpkr: {data: trngNewSpkr},
        trngError: {data: trngError, set: setTrngError},
        trngSlctdTmplt: {data: trngSlctdTmplt, set: setTrngSlctdTmplt},
        trngTabsErr: {data: trngTabsErr, set: setTrngTabsErr},
		// PLAN -> CREATIVE BRIEF
		cbForm: {data: cbForm, set: setCbForm},
		cbFormDflt: {data: cbFormDflt},
		cbSubmit: {data: cbSubmit, set: setCbSubmit},
		cbError: {data: cbError, set: setCbError},
		cbLists: {data: cbLists, set: setCbLists},
		cbLoader: {data: cbLoader, set: setCbLoader},
    }
}
